var map = {
	"./depor": 108,
	"./depor.ts": 108,
	"./elcomercio": 109,
	"./elcomercio.ts": 109,
	"./gestion": 110,
	"./gestion.ts": 110,
	"./trome": 111,
	"./trome.ts": 111,
	"./types": 112,
	"./types.ts": 112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 182;